import {
    LIQUID_BOTTLE_HAS_ERRORED,
    LIQUID_BOTTLE_FETCH_DATA_SUCCESS,
    CLEAR_LIQUID_BOTTLE,

    LIQUID_BOTTLE_TAKE_HAS_ERRORED,
    LIQUID_BOTTLE_RELEASE_HAS_ERRORED,

    SET_MY_LIQUID_BOTTLES,
    GET_LIQUID_BOTTLE_ASSIGNED_TO_ME,
} from './liquidBottlesConstants';
import { setValue } from '../../lib/immutable_wrapper'

const initialLiquidBottlesState = {
    myLiquidBottles: [],
    liquidBottlesAssignedToMe: [],
}

export function liquidBottles(state = initialLiquidBottlesState, action) {
    switch (action.type) {
        case SET_MY_LIQUID_BOTTLES:
            return setValue(state, ['myLiquidBottles'], action.myLiquidBottles);
        case GET_LIQUID_BOTTLE_ASSIGNED_TO_ME:
            return setValue(state, ['liquidBottlesAssignedToMe'], action.liquidBottlesAssignedToMe);
        default:
            return state;
    }
}

export function liquidBottleHasErrored(state = false, action) {
    switch (action.type) {
        case LIQUID_BOTTLE_HAS_ERRORED:
            return action.hasErrored;
        default:
            return state;
    }
}
export function liquidBottle(state = [], action) {
    switch (action.type) {
        case LIQUID_BOTTLE_FETCH_DATA_SUCCESS:
        case CLEAR_LIQUID_BOTTLE:
            return action.liquidBottle;
        default:
            return state;
    }
}

export function liquidBottleTakeHasErrored(state = false, action) {
    switch (action.type) {
        case LIQUID_BOTTLE_TAKE_HAS_ERRORED:
            return action.hasErrored;
        default:
            return state;
    }
}

export function liquidBottleReleaseHasErrored(state = false, action) {
    switch (action.type) {
        case LIQUID_BOTTLE_RELEASE_HAS_ERRORED:
            return action.hasErrored;
        default:
            return state;
    }
}